import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/navigation';
import { Header } from './components/header';
import { Features } from './components/features';
import { About } from './components/about';
import { Services } from './components/services';
import { ROICalculator } from './components/roiCalculator';
import { Testimonials } from './components/testimonials';
import { Pricing } from './components/pricing';
import { Contact } from './components/contact';
import { ComingSoon } from './components/ComingSoon';
import CompliancePage from './components/CompliancePage';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import JsonData from './data/data.json';
import SmoothScroll from 'smooth-scroll';
import './App.css';

// Toggle this to show/hide the Coming Soon page
// Set to false to restore the full landing page
const SHOW_COMING_SOON = true;

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const LandingPage = () => {
  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  // Show Coming Soon page if enabled
  if (SHOW_COMING_SOON) {
    return <ComingSoon />;
  }

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Features data={landingPageData.Features} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <ROICalculator />
      <Testimonials data={landingPageData.Testimonials} />
      <Pricing data={landingPageData.Pricing} />
      <Contact data={landingPageData.Contact} />
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/compliance/:slug" element={<CompliancePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      </Routes>
    </Router>
  );
};

export default App;
